import { Accordion, AccordionDetails, AccordionSummary, Box, Button, Grid, TextField, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useState } from "react";
import { updateOrgDetails } from "./admin_helper";

function OrgProfile({ data, onStateChange }) {
    const [inputErrors, setInputErrors] = useState({});

    const validateInputs = () => {
        setInputErrors({});
        return true;
    }
    const handleOrgDetailsSave = (event) => {
        event.preventDefault();
        const data = new FormData(event.currentTarget);
        onStateChange(false);
        const name = data.get("name");
        const phone = data.get("phone");
        const email = data.get("email");
        const add_1 = data.get("add_1");
        const add_2 = data.get("add_2");
        const add_3 = data.get("add_3");
        const pincode = Number(data.get("pincode"));

        var flag = true;
        if (pincode < 100000 && pincode > 999999 ) {
            setInputErrors({ inputErrors, "pincode": "Invalid pincode." });
            flag = false;
        }

        if (flag) {
            const _json = {
                "name": name, "phone": phone, "email": email, "add_1": add_1,
                "add_2": add_2, "add_3": add_3, "pincode": pincode
            };
            onStateChange(true);
            updateOrgDetails(_json).then((res) => {
                onStateChange(false);
                console.log(res);
            }).catch((err) => {
                onStateChange(false);
                console.error(err);
            })
        }
    }

    return (
        <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="password-change" id="password-change">
                <Typography color="primary" variant="body2" component="span">Organization Setting</Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Box component="form" onSubmit={handleOrgDetailsSave}>
                    <Grid container spacing={2}>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="name" error={inputErrors.name} helperText={inputErrors.name} defaultValue={data?.name ?? ""} fullWidth type="text" placeholder="Name" label="Name" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="phone" error={inputErrors.phone} helperText={inputErrors.phone} defaultValue={data?.phone ?? ""} fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 1111111111, max: 9999999999 } }} placeholder="Phone" label="Phone" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="email" error={inputErrors.email} helperText={inputErrors.email} defaultValue={data?.email ?? ""} fullWidth type="email" placeholder="Email" label="Email" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="add_1" error={inputErrors.add_1} helperText={inputErrors.add_1} defaultValue={data?.add_1 ?? ""} fullWidth type="text" placeholder="Line 1" label="Address Line 1" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="add_2" error={inputErrors.add_2} helperText={inputErrors.add_2} defaultValue={data?.add_2 ?? ""} fullWidth type="text" placeholder="Line 2" label="Address Line 2" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="add_3" error={inputErrors.add_3} helperText={inputErrors.add_3} defaultValue={data?.add_3 ?? ""} fullWidth type="text" placeholder="Line 3" label="Address Line 3" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>
                            <TextField variant="outlined" name="pincode" error={inputErrors.pincode} helperText={inputErrors.pincode} defaultValue={data?.pincode ?? ""} fullWidth type="number" slotProps={{ htmlInput: { step: 1, min: 111111, max: 999999 } }} placeholder="Pincode" label="Pincode" />
                        </Grid>
                        <Grid size={{ xs: 12, sm: 4 }}>

                        </Grid>
                        <Grid size={{ xs: 12, sm: 12 }}>
                            <Button type="submit" variant="contained" fullWidth onClick={validateInputs} color="info" style={{ textTransform: "none" }}>Save Organization</Button>
                        </Grid>
                    </Grid>
                </Box>
            </AccordionDetails>
        </Accordion>
    );
}
export default OrgProfile;
